import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ProdOrderPriority } from '../prod-orders/prod-order'

@Directive({
  selector: '[appOrderPrioritySelect]',
})
export class OrderPrioritySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)
  private enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = this.enumTranslationService.enumDataSource(
      ProdOrderPriority,
      'orders.orderPriority',
      false
    )
  }
}
